import { useTranslation } from 'react-i18next';
import trueSVG from 'assets/images/assignments/true.svg';
import falseSVG from 'assets/images/assignments/false.svg';
import { Button } from 'components/Button';
import { Heading } from 'components/Typography';

type Props = {
  answer: boolean;
  answerLong: string;
  onContinue: () => void;
};

export const AnswerAndContinueContent = ({ answerLong, onContinue, answer }: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <img src={answer ? trueSVG : falseSVG} alt="" className="max-h-[100px] h-full" />

      <Heading level="h4" useDefaultMargins className="text-center whitespace-pre-line">
        {answerLong}
      </Heading>

      <Button size="lg" onClick={onContinue}>
        {t('learningPath.knowledgeCheck.continue')}
      </Button>
    </>
  );
};
